import React, { useEffect } from 'react';
import { programas } from '../../json/programas';
import { programas_2025 } from '../../json/programas_2025';
import './programas.css';

const Programas = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Fortalecimiento de la Vinculación y Movilidad Laboral Primero el Pueblo 2026</h3>
                <hr className='hr-gob'/>
            </div>
                {
                programas.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_programas'>
                            <div className='card_cero'>
                                <h5>{ item.titulo }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">Ver mas...</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }

        </div>
        
        <div className='row'>
            <div>
                <h3 className='title'>Fortalecimiento de la Vinculación y Movilidad Laboral Primero el Pueblo 2025</h3>
                <hr className='hr-gob'/>
            </div>
                {
                programas_2025.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_programas'>
                            <div className='card_cero'>
                                <h5>{ item.titulo }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">Ver mas...</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }

        </div>
    </div>
  )
}
export default Programas